const { primeOrder: editions } = require('~/config/editions/ClientSafeEditions');

/**
 * Returns true if the provided URL host doesn't match any of the HuffPost editions.
 * @param {URL} url
 * @return {boolean}
 */
function isExternalUrl(url) {
  if (url) {
    const isInternal = editions
      .some(({ hostname }) => url.host === hostname || url.host.endsWith(`.${hostname}`));

    return !isInternal && !url.host.endsWith('.huffingtonpost.com');
  }

  return true;
}

module.exports = isExternalUrl;
